module.exports = __webpack_public_path__ + "static/img/wonderful-title.13a6351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wonderful-title.png
// module id = JIch
// module chunks = 1